import "vuetify/styles";

import { createVuetify } from "vuetify";
import { VPullToRefresh } from "vuetify/components";
import { fa } from "vuetify/iconsets/fa-svg";
import { nl } from "vuetify/locale";

import { aliases } from "./icons";

export default createVuetify({
  components: {
    VPullToRefresh
  },
  icons: {
    defaultSet: "fa",
    aliases,
    sets: { fa }
  },
  locale: {
    locale: "nl",
    messages: { nl }
  },
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        colors: {
          primary: "#122338",
          secondary: "#2A455E",
          accent: "#39838E",
          secondaryaccent: "#B2DD00",
          background: "#cedce9",
          surface: "#FFFFFF",
          "on-surface": "#122338",
          "on-background": "#122338",
          highEmphasisBtn: "#122338",
          subtle: "#F8F9FA",
          "on-subtle": "#122338"
        },
        variables: {
          "border-color": "#000000",
          // 'border-opacity': 0.12,
          // "high-emphasis-opacity": 0.87,
          // 'medium-emphasis-opacity': 0.60,
          // 'disabled-opacity': 0.38,
          // 'idle-opacity': 0.04,
          "hover-opacity": 0.08
          // 'focus-opacity': 0.12,
          // 'selected-opacity': 0.08,
          // 'activated-opacity': 0.12,
          // 'pressed-opacity': 0.12,
          // 'dragged-opacity': 0.08,
          // 'theme-kbd': '#212529',
          // 'theme-on-kbd': '#FFFFFF',
          // 'theme-code': '#F5F5F5',
          // 'theme-on-code': '#000000',
        }
      },
      dark: {
        colors: {
          primary: "#122338",
          secondary: "#2A455E",
          accent: "#39838E",
          secondaryaccent: "#B2DD00",
          background: "#121212",
          highEmphasisBtn: "#FFFFFF"
        }
      }
    }
  },
  defaults: {
    global: { ripple: false },
    VTextField: {
      variant: "outlined",
      density: "compact",
      bgColor: "surface"
    },
    VFileInput: {
      variant: "outlined",
      density: "compact"
    },
    VAutocomplete: {
      variant: "outlined",
      density: "compact"
    },
    VSelect: {
      variant: "outlined",
      density: "compact"
    },
    VCard: {
      VCardActions: {
        class: "justify-center",
        VBtn: {
          slim: false,
          variant: "outlined"
        }
      },
      elevation: 1
    },
    VBtn: {
      variant: "outlined",
      color: "highEmphasisBtn"
    },
    VTabs: {
      bgColor: "surface",
      class: "rounded-lg"
    }
  }
});
